import { Box, Heading } from '@99designs/emu';
import {
    FAQFormattedAnswer,
    FlexibleColumnFAQs,
    QuestionAnswerProps,
} from '@99designs/marketing-ui';
import type { FixedPriceProjectProductAdditionalDetail } from '../../types/Product';

type Props = {
    items: FixedPriceProjectProductAdditionalDetail[];
};

const formatToFaq = (items: FixedPriceProjectProductAdditionalDetail[]): QuestionAnswerProps[] => {
    return items.map(
        ({ title, description, ctaLink }: FixedPriceProjectProductAdditionalDetail) => ({
            question: title,
            answer: getFormattedAnswer(description, ctaLink),
        })
    );
};

const getFormattedAnswer = (answer: string, ctaLink: string | null) => {
    return (
        <Box paddingBottom="1.5bu" as="p">
            <FAQFormattedAnswer answer={__(answer)} linksReplacements={{ Link: ctaLink || '' }} />
        </Box>
    );
};

export function AdditionalCost({ items }: Props) {
    return (
        <>
            <Heading appearanceLevel={4} accessibilityLevel={2}>
                {__('Things that might cost more outside of this package')}
            </Heading>
            <Box display="flex" paddingY="2bu" flexDirection="column">
                <FlexibleColumnFAQs
                    onOpen={() => {
                        return true;
                    }}
                    faqSections={[formatToFaq(items)]}
                />
            </Box>
        </>
    );
}
